// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__L9QDR","boxTitle":"Qualiphy_boxTitle__3R5kw","box":"Qualiphy_box__2sgGh","toggleWrap":"Qualiphy_toggleWrap__2kazJ"};